// Replace Okta with MSAL
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { ErrorBoundary } from 'react-error-boundary';
import { useRoutes } from 'react-router-dom';

import ErrorFallback from './components/ErrorFallback';
import SWRConfigWrapper from './components/SWRConfigWrapper';
import { GtmProvider } from './contexts/GtmContext';
import { PostFilterProvider } from './contexts/PostFilterContext';
import { SettingsProvider, SettingsConsumer } from './contexts/SettingsContext';
import { SnackbarProvider } from './contexts/SnackbarContext';
import { UserProvider } from './contexts/UserContext';
import { msalConfig } from './entraConfig';
import routes from './routes';
import { createTheme } from './theme';

import './i18n';

// Initialize MSAL instance outside of the component to prevent re-renders
const msalInstance = new PublicClientApplication(msalConfig);

const App = () => {
  const contents = useRoutes(routes);

  return (
    /* Replace <Security> with <MsalProvider> */
    <MsalProvider instance={msalInstance}>
      <SettingsProvider>
        <SettingsConsumer>
          {({ settings }) => (
            <ThemeProvider theme={createTheme({ mode: settings.theme })}>
              <ErrorBoundary fallbackRender={ErrorFallback}>
                <SWRConfigWrapper>
                  <UserProvider>
                    <GtmProvider>
                      <CssBaseline />
                      <SnackbarProvider>
                        <PostFilterProvider>{contents}</PostFilterProvider>
                      </SnackbarProvider>
                    </GtmProvider>
                  </UserProvider>
                </SWRConfigWrapper>
              </ErrorBoundary>
            </ThemeProvider>
          )}
        </SettingsConsumer>
      </SettingsProvider>
    </MsalProvider>
  );
};

export default App;
